import React from "react"
import { Icon } from "@iconify/react"
import Colors from "constants/Colors"

const IconifyIcon = ({
  icon,
  width = 30,
  height = 30,
  className = "",
  onClick,
  style,
  ...props
}) => {
  return (
    <Icon
      icon={icon}
      width={width}
      height={height}
      className={`cursor-pointer ${className}`}
      onClick={onClick}
      style={{ color: Colors.primary, ...style }}
      {...props}
    />
  )
}

export default IconifyIcon
